<ng-container *ngIf="validando == 1; else responseValidacion;">
    <div class="col-12 text-left">
        <mat-progress-bar class="m-auto mt-20x" [color]="styleCocheSeguro?.colorBtn" mode="indeterminate"></mat-progress-bar>
    </div>
</ng-container>
<ng-template #responseValidacion>
    <div>{{mensajeResponse}}</div>
</ng-template>